import React from "react";
import { css } from "@linaria/core";
import type { Project } from "../../../api/useProjects";
import { toPath } from "../../../router/helpers/path";
import { color } from "@ui/index";
import { fonts } from "@ui/Theme";
import Link from "@ui/Link";
import t from "../../../i18n";

interface P {
  project: Project;
  pathName: string;
}

const Breadcrumb = ({ project, pathName }: P) => (
  <div className={BreadcrumbWrapper}>
    <Link
      className={StyledLink}
      to={toPath("/projects/:projectId/settings", { projectId: project.id })}
    >
      {t("project.secondary_header.settings.title")}
    </Link>
    <div>{">"}</div>
    <div>{pathName}</div>
  </div>
);

export default Breadcrumb;

//#region CSS
const BreadcrumbWrapper = css`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const StyledLink = css`
  color: ${color.lightNitrogen500_Main};
  font: ${fonts.body1};
  font-weight: 500;
  :hover {
    text-decoration: underline;
  }
`;

//#endregion CSS
